<template>
    <v-row>
        <v-col>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                Dades d'usuari
                            </th>
                            <th class="text-left"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="full_name">
                            <td>Nom i cognoms</td>
                            <td>{{ userEngagement.full_name }}</td>
                        </tr>
                        <tr key="connector">
                            <td>La darrera empresa creada és de: </td>
                            <td>{{ userEngagement.connector }}</td>
                        </tr>
                        <tr key="email">
                            <td>Correu</td>
                            <td>{{ userEngagement.email }}</td>
                        </tr>
                        <tr key="phoneNumber">
                            <td>Telèfon</td>
                            <td>{{ userEngagement.phone_number }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
        <v-col>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                Dades de contracte
                            </th>
                            <th class="text-left"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="documents">
                            <td>Documents</td>
                            <td>{{ currentDocs }}</td>
                        </tr>
                        <tr key="inici">
                            <td>Data d'inici</td>
                            <td>{{ userEngagement.contract.start_date }}</td>
                        </tr>
                        <tr key="expiracio">
                            <td>Data d'expiració</td>
                            <td>{{ userEngagement.contract.end_date }}</td>
                        </tr>
                        <tr key="last_document_upload">
                            <td>Fecha última factura subida</td>
                            <td>{{ userEngagement.last_document_upload }}</td>
                        </tr>

                    </tbody>
                </template>
            </v-simple-table>
        </v-col>
    </v-row>
</template>

<script>

import { getUserEngagementDataApi } from '@/modules/userEngagement/infrastructure/getUserEngagementData';

export default {
    data: () => ({
        userEngagement: {
            id: "",
            connector: "",
            email: "",
            phone_number: "",
            full_name: "",
            contract: {
                "used_docs": "",
                "max_docs": "",
                "start_date": "",
                "end_date": ""
            },
            last_document_upload: ""
        },
    }),
    computed: {
        currentDocs() {
            return `${this.userEngagement.contract.used_docs} / ${this.userEngagement.contract.max_docs}`
        }
    },
    async mounted() {
        this.userEngagement = await getUserEngagementDataApi().execute()
    },
}
</script>